import { GetAllProvinciasDtoProps } from "./DTOs/GetAllProvinciasDto"

export const GetAllProvinciasDtoAdapter = (
  provincia: GetAllProvinciasDtoProps
) => ({
  id: provincia.id,
  codigoIne: provincia.codigoIne,
  nombre: provincia.nombre,
  paisId: provincia.paisId,
})
